import { action, makeAutoObservable } from "mobx";
import * as _ from "lodash";
import { AxiosInstance, AxiosResponse } from "axios";

import env from "../../../config/env";
import http from "../../../services/http";
import {
  ComboBoxData,
  DataTableItemsDto,
  MessageResultState,
  ServiceResult,
} from "../../../types/general-types";
import IPagedResult from "../../../models/dto/fetch/IPagedResult";
import {
  SSOExternalUserCreateDto,
  SSOExternalUserDto,
  SSOExternalUserGridListDto,
  SSOExternalUserUpdateDto,
  SSOPermissionCreateDto,
  SSOPermissionListDto,
} from "./types";
import IPagedRequest from "../../../models/dto/fetch/IPagedRequest";
import qs from "qs";

const { API_BASE_URL } = env;
let reportPeriod: string = "";

class ExternalUserManagementStore {
  static readonly id: string = "ExternalUserManagementStore";

  externalUsers!: IPagedResult<SSOExternalUserGridListDto>;

  get api() {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }
  constructor() {
    makeAutoObservable(this);

    this.externalUsers = {
      totalCount: 0,
      items: [],
      isLoaded: false,
    };

    this.all = this.all.bind(this);
  }

  @action.bound async all(params: IPagedRequest | undefined) {
    this.externalUsers.isLoaded = false;

    const q = qs.stringify(params, {
      encodeValuesOnly: true,
      addQueryPrefix: true,
    });
    const response: AxiosResponse<
      ServiceResult<DataTableItemsDto<SSOExternalUserGridListDto>>
    > = await this.api.get("/sso-external-user/all" + q);
    const externalUsers = response.data.result;
    this.externalUsers = { ...externalUsers, isLoaded: true };
  }

  @action.bound async create(input: SSOExternalUserCreateDto) {
    const result: ServiceResult<SSOExternalUserDto> = await (
      await this.api.post(`/sso-external-user/create`, input)
    ).data;
    if (result.state === MessageResultState.SUCCESS)
      await this.all({ maxResultCount: 5, skipCount: 0 });
    return result;
  }
  @action.bound async createPermission(input: SSOPermissionCreateDto) {
    const result: ServiceResult<SSOPermissionListDto> = await (
      await this.api.post(`/sso-external-user/create-permisson`, input)
    ).data;
    return result;
  }

  @action.bound async update(input: SSOExternalUserUpdateDto) {
    const result: ServiceResult<SSOExternalUserDto> = await (
      await this.api.put(`/sso-external-user/update`, input)
    ).data;
    if (result.state === MessageResultState.SUCCESS)
      await this.all({ maxResultCount: 5, skipCount: 0 });
    return result;
  }

  @action.bound async delete(id: number) {
    const result: ServiceResult<SSOExternalUserDto> = await (
      await this.api.delete(`/sso-external-user/delete/${id}`)
    ).data;
    await this.all({ maxResultCount: 5, skipCount: 0 });
    return result;
  }

  @action.bound async GetUserPermissions(userId: number) {
    const response: ServiceResult<SSOPermissionListDto> = (
      await this.api.get(`/sso-external-user/get-user-permissons/${userId}`)
    ).data;

    return response;
  }
}

export default ExternalUserManagementStore;
